import React from 'react';
import { ReactComponent as CrossMark } from 'style/icons/close-small.svg';
import { ReactComponent as CheckMark } from 'style/icons/icon-checkmark.svg';
import './PasswordValidationHint.scss';
import Label from 'components/form/Label/Label';

const PasswordValidationIcon = ({ datatestid, passed }) => {
  if (passed) {
    return (
      <CheckMark
        data-testid={`${datatestid}-correctIcon`}
        className="validationIcon"
      />
    );
  } else {
    return (
      <CrossMark
        data-testid={`${datatestid}-wrongIcon`}
        className="validationIcon"
      />
    );
  }
};

function PasswordValidationHint(props) {
  return (
    <span
      className="passwordValidationContainer flex-container align-items-center"
      data-testid="password-validation"
      style={{ marginRight: '8px' }}
    >
      <PasswordValidationIcon
        datatestid={props.datatestid}
        passed={props.passed}
      />
      <Label
        data-testid={props.datatestid}
        className="verification-item padL4"
        type="body-1"
      >
        {props.message}
      </Label>
    </span>
  );
}

export default PasswordValidationHint;
